export const isLiteMode = import.meta.env.VITE_LITE_MODE == 'true';
